export interface VirtualRowWindow {
  readonly start: number;
  readonly end: number;
}

export function virtualRowWindow(
  rowCount: number,
  scrollTop: number,
  viewportHeight: number,
  rowHeight: number,
  overscan: number,
): VirtualRowWindow {
  if (rowCount <= 0 || rowHeight <= 0) return { start: 0, end: 0 };
  const safeScrollTop = Math.max(0, scrollTop);
  const safeViewportHeight = Math.max(rowHeight, viewportHeight);
  const visibleStart = Math.floor(safeScrollTop / rowHeight);
  const visibleEnd = Math.ceil((safeScrollTop + safeViewportHeight) / rowHeight);
  return {
    start: Math.max(0, visibleStart - overscan),
    end: Math.min(rowCount, visibleEnd + overscan),
  };
}
